<template>
  <v-layout justify-center>
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Filtros :</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Referência" clearable v-model="filters.externalId"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" lg="6">
                <v-dialog ref="toggleStartDate" v-model="toggleStartDate" :return-value.sync="filters.startDate"
                  persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filters.startDate" label="Data De:" v-on="on" clearable></v-text-field>
                  </template>
                  <v-date-picker :max="filters.endDate" locale="pt-pt" v-model="filters.startDate" scrollable>
                    <v-btn text color="primary" @click="toggleStartDate = false">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.toggleStartDate.save(filters.startDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" lg="6">
                <v-dialog ref="toggleEndDate" v-model="toggleEndDate" :return-value.sync="filters.endDate" persistent
                  width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="filters.endDate" label="Data Até:" v-on="on" clearable></v-text-field>
                  </template>
                  <v-date-picker :min="filters.startDate" locale="pt-pt" v-model="filters.endDate" scrollable>
                    <v-btn text color="primary" @click="toggleEndDate = false">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.toggleEndDate.save(filters.endDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select v-model="filters.addressId" :items="addresses" item-text="value" item-value="id"
                  label="Loja"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select v-model="filters.docType" :items="docTypes" item-text="name" item-value="value"
                  label="Documento" clearable></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" lg="6">
                <v-select v-model="filters.orderDirection" :items="orderOptions" label="Ordenar Data :"></v-select>
              </v-col>

              <v-col cols="12" lg="6">
                <v-switch v-model="filters.showOnlyRedDocs" label="Ver apenas documentos por liquidar"></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="cleanFilters()">Limpar</v-btn>
          <v-spacer />
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="show = false">Fechar</v-btn>
          <v-btn color="blue darken-1" text @click="confirm()">Procurar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "FilterDialog",
  props: ["docTypes", "addresses"],
  data() {
    return {
      filters: {
        startDate: null,
        endDate: null,
        externalId: null,
        showOnlyRedDocs: false,
        doctype: '',
        addressId: null,
        orderDirection: 'DESC'
      },
      orderOptions: ['DESC', 'ASC'],
      toggleStartDate: false,
      toggleEndDate: false,
      show: false,
    };
  },
  methods: {
    toggle() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    cleanFilters() {
      this.filters.externalId = null;
      this.filters.startDate = null;
      this.filters.addressId = null;
      this.filters.endDate = null;
      this.filters.showOnlyRedDocs = false;
      this.filters.docType = "";
      this.filters.orderDirection = false;
    },
    confirm() {
      this.$emit("doFilter");
      this.toggle();
    }
  },
  async mounted() {
  },
};
</script>
<style></style>
